/**
 * Reset security flow error code enum.
 */
export enum RESET_SECURITY_FLOW_ERROR_CODE {
  WRONG_TYPE = 'wrong-type',
  WRONG_MFA_TYPE = 'wrong-mfa-type',
  MFA_TOKEN_REQUIRED = 'mfa-token-required',
}
